














import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class ReviewTabs extends Vue {

  get isCurrentTab() {
    return this.$route.meta.historyName;
  }

}
